import { LayerViewModel } from "@omnia/shared/layers/layerViewModel"
import { FieldViewModel, isArray, isNumber } from "../../../omnia"
import { IDataLayerZone, INtrBalance, NutrientType } from "../../../types"
import { getNutrientTypes } from "../../../utils"
import { INutritionMapViewContext } from "../types"
import { RequirementsMapView } from "./requirements"
import { FieldsMapLabels } from "@omnia/shared/fields/types"
import { sortDates } from "@omnia/shared/utils/utils"
import { RequirementsLayerViewerFactory } from "@omnia/shared/nutrition/map/requirementsLayerViewer"


export class OpeningBalanceMapView extends RequirementsMapView {

    static create(ctxt: INutritionMapViewContext) {

        let views = getNutrientTypes().map(nutrientType => {

            let view = new OpeningBalanceMapView("Opening balance", "ob", nutrientType, ctxt)
            view.setup()
            return view

        })

        return views

    }

    protected constructor(name: string, key: string, nutrientType: NutrientType, ctxt: INutritionMapViewContext) {
        super(name, key, nutrientType, ctxt)
    }

    public showLayers(visibilityFilter?: (l: LayerViewModel) => boolean, labels: FieldsMapLabels = this._labels) {

        super.showLayers(visibilityFilter, labels)

        const balance = this.ctxt.nutritionSvc.balance

        if (!balance.zonesLoaded) {
            balance.loadZones().then(() => this.refreshLayers())
        }

    }

    protected createViewer() {

        return RequirementsLayerViewerFactory.createForNutrient(this.nutrientType, "", true)

    }

    protected createLayers(): LayerViewModel[] {

        const nutrientKey = NutrientType[this._nutrient]
        const ctxt = this.ctxt.datalayerContext

        const cropping = this.ctxt.fieldSvc.cropping.filter(c => c.hasBoundary())

        const balance = this.ctxt.nutritionSvc.balance

        let layerId = 0

        return cropping
            .sort((a, b) => sortDates(a.startDate, b.startDate))
            .map(c => {

                const croppingBalance = this.filterNutrientGroup(

                    balance.zonesLoaded
                        ? balance.get(c.croppingId).filter(b => !b.Aggregate)
                        : [balance.getWholeField(c.croppingId)].filter(b => !!b)

                )

                if (croppingBalance.length) {

                    const zones = createBalanceZones(c, croppingBalance, nutrientKey)

                    const layer = this.createLayer(++layerId, c, zones)

                    const vm = new LayerViewModel(ctxt, this.ctxt.map, layer, c.fieldVm)

                    return vm

                }


            })
            .filter(l => !!l)

    }

    protected refreshViewers() {

        super.refreshViewers()

        if (isArray(this._colors)) {

            this._colors = this._colors.map(c => ({
                ...c,
                Value: isNumber(c.Value) && !!c.Value ? -c.Value : c.Value
            }))

        }
    }


}

function createBalanceZones(cropping: FieldViewModel, balance: INtrBalance[], nutrientKey: string) {

    let zoneId = 0

    let zones: IDataLayerZone[] = balance.map(b => {

        let value = b[nutrientKey]
        value = isNumber(value) ? -value : (value || 0)

        const name = b.Zone ? String(b.ZoneNumber) : cropping.fieldName
        const geom = b.Geometry || cropping.cropping.Boundary
        const area = b.Geometry ? b.Area : (cropping.area * 10000)

        const zone = <IDataLayerZone>{
            DataLayerZoneId: b.NtrBalanceId || ++zoneId,
            LayerId: null,
            Number: b.ZoneNumber,
            Geometry: geom,
            Area: area,
            Value: value,
            Name: name,
            Data: b
        }

        return zone

    })

    return zones

}
